export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/60"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="w-full flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="flex-1 w-full flex flex-col items-start gap-5">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold font-label tracking-wide">
              <i className="ri-fire-line text-sm"></i>
              今日热播
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-extrabold text-foreground-950 leading-tight tracking-tight">
              豆花视频 - 免费高清影视聚合平台
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-medium font-body">
              海量资源 · 流畅不卡 · 每日更新
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl font-body">
              豆花视频专注免费在线观影体验，汇集西瓜视频、芒果视频、丝瓜视频等优质影视资源。覆盖电影大全、电视剧全集、热门综艺与动漫番剧，高清画质不缓冲，每日同步更新最新剧集，是你追剧看片的理想之选。
            </p>

            <div className="flex flex-wrap items-center gap-5 md:gap-8">
              <div className="flex flex-col">
                <span className="text-xl md:text-2xl font-heading font-extrabold text-primary-600">10000+</span>
                <span className="text-xs text-foreground-500 font-body">覆盖影片</span>
              </div>
              <div className="flex flex-col">
                <span className="text-xl md:text-2xl font-heading font-extrabold text-accent-600">200+</span>
                <span className="text-xs text-foreground-500 font-body">日更新量</span>
              </div>
              <div className="flex flex-col">
                <span className="text-xl md:text-2xl font-heading font-extrabold text-secondary-600">1080P+</span>
                <span className="text-xs text-foreground-500 font-body">高清流畅</span>
              </div>
            </div>

            <div className="flex items-center gap-3 pt-2">
              <a
                href="#media"
                onClick={(e) => handleClick(e, '#media')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold font-label rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-base"></i>
                立即观影
              </a>
              <a
                href="#about"
                onClick={(e) => handleClick(e, '#about')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 text-sm font-semibold font-label rounded-lg hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-right-line text-base"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20cinematic%20abstract%20composition%20with%20warm%20coral%20orange%20and%20deep%20charcoal%20gradients%2C%20geometric%20play%20button%20and%20film%20reel%20shapes%20in%20minimalist%20modern%20digital%20art%20style%2C%20soft%20glowing%20highlights%2C%20clean%20dark%20background%2C%20entertainment%20streaming%20vibes%2C%20high%20quality%20abstract%20art&width=1000&height=750&seq=douhua-hero-visual&orientation=landscape"
                alt="豆花视频 - 免费高清影视聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}